import state from './sectionsState'
import getters from './sectionsGetters'
import actions from './sectionsActions'
import mutations from './sectionsMutations'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
